import { watchFetchBeMinDetails } from './fetchBeMinDetails';
import { watchSaveAddress } from './saveAddress';
import { watchSearchBusinessEntities } from './searchBusinessEntities';
import { watchUpdateBeCompetitors } from './updateBeCompetitors';
import { watchUpdateBeMarketSegments } from './updateBeMarketSegments';
import { watchUpdateBeProductCategories } from './updateBeProductCategories';
import { watchUpdateBeRankType } from './updateBeRankType';

export const businessEntitySagas = [
  watchSaveAddress(),
  watchSearchBusinessEntities(),
  watchUpdateBeCompetitors(),
  watchFetchBeMinDetails(),
  watchUpdateBeRankType(),
  watchUpdateBeMarketSegments(),
  watchUpdateBeProductCategories()
];
